import { IRoute } from "../../interfaces/others/IRoute";

export const Routes: IRoute[] = [
  {
    name: "Solicitudes",
    to: "/solicitudes",
    activeKey: "solicitudes",
    validRoles: [
      "Administrador",
      "Lider de sucursal",
      "Reclutador",
      "Administrador-",
    ],
    icon: "rectangle-list",
  },
  {
    name: "Colaboradores",
    to: "/colaboradores",
    activeKey: "colaboradores",
    validRoles: [
      "Administrador",
      "Lider de sucursal",
      "Contador",
      "Talento humano",
      "Reclutador",
      "Administrador-",
    ],
    icon: "people-group",
    children: [
      {
        name: "Suspendidos",
        to: "/colaboradores/suspendidos",
        activeKey: "colaboradores-suspendidos",
        validRoles: [
          "Administrador",
          "Administrador-",
          "Lider de sucursal",
          "Talento humano",
        ],
        icon: "user-slash",
      },
      {
        name: "Control de bajas",
        to: "/colaboradores/control-bajas",
        activeKey: "colaboradores-control-bajas",
        validRoles: [
          "Administrador",
          "Administrador-",
          "Lider de sucursal",
          "Talento humano",
        ],
        icon: "user-clock",
      },
    ],
  },
  {
    name: "Calendario",
    to: "/calendar",
    activeKey: "calendar",
    validRoles: ["Administrador", "Reclutador", "Administrador-"],
    icon: "calendar",
  },
  {
    name: "Calendario Líder",
    to: "/leader-calendar",
    activeKey: "leader-calendar",
    validRoles: [
      "Lider de sucursal",
      "Líder de Sucursal SUC",
      "Líder de Sucursal",
      "Líder de líderes",
    ],
    icon: "calendar-days",
  },
  {
    name: "Vacantes",
    to: "/vacantes",
    activeKey: "vacantes",
    validRoles: ["Administrador", "Administrador-", "Reclutador"],
    icon: "id-card",
  },
  {
    name: "Puestos",
    to: "/puestos",
    activeKey: "puestos",
    validRoles: ["Administrador", "Administrador-"],
    icon: "check-to-slot",
    children: [
      {
        name: "Documentos",
        to: "/documents",
        activeKey: "documents",
        validRoles: ["Administrador", "Administrador-"],
        icon: "file-circle-check",
      },
    ],
  },
  {
    name: "Plantillas",
    to: "/plantillas",
    activeKey: "plantillas",
    validRoles: ["Administrador", "Administrador-"],
    icon: "file",
  },
  {
    name: "Táctica operativa",
    to: "/tactica-operativa",
    activeKey: "tactica-operativa",
    validRoles: [
      "Administrador",
      "Administrador-",
      "Líder de líderes",
      "Reclutador",
    ],
    icon: "chess",
  },
  {
    name: "Lista negra",
    to: "/lista-negra",
    activeKey: "lista-negra",
    validRoles: [
      "Administrador",
      "Administrador-",
      "Reclutador",
      "Talento humano",
    ],
    icon: "address-book",
  },
  // {
  //   name: "Revisión de documentos",
  //   to: "/revision-documentos",
  //   activeKey: "revision-documentos",
  //   validRoles: [
  //     "Administrador",
  //     "Administrador-",
  //     "Reclutamiento",
  //     "Reclutador",
  //     "Talento humano",
  //     "Lider de sucursal",
  //   ],
  //   icon: "file-circle-check",
  // },
  {
    name: "Usuarios",
    to: "/usuarios",
    activeKey: "usuarios",
    validRoles: ["Administrador", "Administrador-"],
    icon: "user",
  },
  {
    name: "Expediente",
    to: "/mi-expediente",
    activeKey: "expediente",
    validRoles: ["Trabajador"],
    icon: "folder-open",
  },
  {
    name: "Incapacidades",
    to: "/incapacidades",
    activeKey: "/incapacidades",
    validRoles: ["Trabajador"],
    icon: "user-injured",
  },
  {
    name: "Permisos",
    to: "/permisos",
    activeKey: "/permisos",
    validRoles: ["Trabajador"],
    icon: "calendar-check",
  },
  {
    name: "Vacaciones",
    to: "/vacaciones",
    activeKey: "/vacaciones",
    validRoles: ["Trabajador"],
    icon: "umbrella-beach",
  },
  {
    name: "Incidencias",
    to: "/incidencias",
    activeKey: "incidencias",
    validRoles: ["Trabajador"],
    icon: "triangle-exclamation",
  },
  {
    name: "Cumpleaños",
    to: "/sucursal/birthdates",
    activeKey: "birthdates",
    validRoles: ["Lider de sucursal"],
    icon: "cake-candles",
  },
  {
    name: "Horario",
    to: "/sucursal/horario",
    activeKey: "horario",
    validRoles: ["Lider de sucursal"],
    icon: "calendar-check",
  },
  
  {
    name: "Incidencias",
    to: "/sucursal/incidencias",
    activeKey: "incidencias",
    validRoles: ["Lider de sucursal"],
    icon: "triangle-exclamation",
  },
  {
    name: "Reporte reloj",
    to: "/sucursal/reporte-reloj",
    activeKey: "/reporte-reloj",
    validRoles: ["Lider de sucursal"],
    icon: "clock",
  },
  {
    name: "Horario semanal",
    to: "/sucursales/config-horario-semanal",
    activeKey: "/config-horario-semanal",
    validRoles: ["Lider de sucursal"],
    icon: "calendar-days",
  },
  {
    name: "Nómina",
    to: "/nomina",
    disabled: false,
    activeKey: "/nomina",
    validRoles: ["Administrador"],
    icon: "money-bill",
    children: [
      {
        name: "Bonos",
        to: "/nomina/bonos",
        activeKey: "/nomina/bonos",
        validRoles: ["Administrador"],
        icon: "circle-dollar-to-slot",
      },
      {
        name: "Deducciones",
        to: "/nomina/deducciones",
        activeKey: "/nomina/deducciones",
        validRoles: ["Administrador"],
        icon: "minus-circle",
      },
      {
        name: "Plantillas Deducciones",
        to: "/nomina/plantillas",
        activeKey: "/nomina/plantillas",
        validRoles: ["Administrador"],
        icon: "bookmark",
      },
      {
        name: "Plantillas Bonos",
        to: "/nomina/plantillas-bonos",
        activeKey: "/nomina/plantillas-bonos",
        validRoles: ["Administrador"],
        icon: "bookmark",
      },
      {
        name: "Incapacidades",
        to: "/incapacidades",
        activeKey: "/incapacidades",
        validRoles: ["Administrador"],
        icon: "user-injured",
      },
      {
        name: "Permisos",
        to: "/permisos",
        activeKey: "/permisos",
        validRoles: ["Administrador"],
        icon: "calendar-check",
      },
      {
        name: "Vacaciones",
        to: "/vacaciones",
        activeKey: "/vacaciones",
        validRoles: ["Administrador"],
        icon: "umbrella-beach",
      },
      {
        name: "Jefes Directos",
        to: "/direct-boss",
        activeKey: "/direct-boss",
        validRoles: ["Administrador", "Lider de sucursal"],
        icon: "user-tie",
      },

      {
        name: "Faltantes en caja",
        to: "/faltantes-caja",
        activeKey: "/faltantes-caja",
        validRoles: ["Administrador"],
        icon: "money-check-dollar",
      },
      {
        name: "Préstamos",
        to: "/prestamos",
        activeKey: "/prestamos",
        validRoles: ["Administrador"],
        icon: "hand-holding-dollar",
      },
      {
        name: "Nómina",
        to: "/nomina",
        activeKey: "/nomina",
        validRoles: ["Administrador"],
        icon: "money-bill-wave",
      },
    ],
  },
];
